module.exports = __webpack_public_path__ + "img/744.36c2ed58.jpg";